<template>
	<div style="background: #F0F0F0">
		<div id="content">
			<div class="mb-set-box clearfix">
				<div class="mb-phone fl">
					<div class="phone-top">
						<img style="z-index:999 !important;" src="../assets/imgs/phone-top.png">
					</div>
					<div ref="Rank" @click="showModel('Rank')">
						<!--左右排列-->
						<div class="person-cover" :class="isFMR?'br_green':''" style="position: relative;" v-if="LR==true">
							<img class="kz" style="width: 100%; height:100%;" :src="form.posterSrc" alt="">
							<div class="person-head">
								<img :src="form.avtarSrc" class="tz" />
							</div>
							<div class="person-text">
								<h3 id="Ln" v-html="form.userName==''?'姓名':form.userName"></h3>
								<p id="Lz" v-html="form.position==''?'职位':form.position"></p>
								<div v-for="(item,index) in comList">
									<p v-if="item.id==0">{{item.comName?item.comName:'公司'}}</p>
									<p v-else>{{item.comName?item.comName:'公司'+item.id}}</p>
								</div>
							</div>

						</div>

						<!--上下排列-->
						<div class="person-cover person-cover2" :class="isFMR?'br_green':''" style=" position: relative;" v-else-if="UD==true">
							<img class="kz" style="width: 100%;height: 100%;" :src="form.posterSrc" alt="">
							<div class="person-head person-head2">
								<img :src="form.avtarSrc" class="tz" />
							</div>
							<div class="person-text person-text2">
								<h3 id="Un" v-html="form.userName==''?'姓名':form.userName"></h3>
								<p id="Uz" v-html="form.position==''?'职位':form.position"></p>
								<div v-for="(item,index) in comList">
									<p v-if="item.id==0">{{item.comName?item.comName:'公司'}}</p>
									<p v-else>{{item.comName?item.comName:'公司'+item.id}}</p>
								</div>
							</div>
						</div>

						<!--右左排列-->
						<div class="person-cover" :class="isFMR?'br_green':''" style="position: relative;" v-else-if="RL==true">
							<img class="kz" style="width: 100%;height: 100%;" :src="form.posterSrc" alt="">
							<div class="person-head person-head3">
								<img :src="form.avtarSrc" class="tz" />
							</div>
							<div class="person-text person-text3">
								<h3 id="Rn" v-html="form.userName==''?'姓名':form.userName"></h3>
								<p id="Rz" v-html="form.position==''?'职位':form.position"></p>
								<div v-for="(item,index) in comList">
									<p v-if="item.id==0">{{item.comName?item.comName:'公司'}}</p>
									<p v-else>{{item.comName?item.comName:'公司'+item.id}}</p>
								</div>
							</div>

						</div>
					</div>

					<div ref="LX" class="big-box1 contact-box white-bj" :class="isLXR?'br_green':''">
						<ul class="contact-list">
							<li>
								<p id="t">固定电话&emsp;&emsp;{{form.telphone}}</p>
							</li>
							<li id="l" v-for="(item,index) in phoneList">
								<p id="p" v-if="item.id==0">移动电话&emsp;&emsp;{{item.phoneNum}}</p>
								<p id="p" v-else>移动电话{{item.id}}&emsp;&emsp;{{item.phoneNum}}</p>
							</li>
							<!-- <template v-for="(item,index) in phoneList">
								<li id="l"  v-if="item.id==0">
									<p id="p">移动电话&emsp;&emsp;{{item.phoneNum}}</p>
								</li>
								<li id="l" v-else-if="item.id !== 0 && item.phoneNum">
									<p id="p">移动电话{{item.id}}&emsp;&emsp;{{item.phoneNum}}</p>
								</li>
							</template> -->
							<li id="fl" v-for="(item,index) in faxList">
								<p id="fp" v-if="item.id==0">传真&emsp;&emsp;&emsp;&emsp;{{item.faxNum}}</p>
								<p id="fp" v-else>传真{{item.id}}&emsp;&emsp;&emsp;&emsp;{{item.faxNum}}</p>
							</li>
							<li id="ml" v-for="(item,index) in emailList">
								<p id="mp" v-if="item.id==0">电子邮箱&emsp;&emsp;{{item.email}}</p>
								<p id="mp" v-else>电子邮箱{{item.id}}&emsp;&emsp;{{item.email}}</p>
							</li>
						</ul>
						<!--遮罩-->
						<div class="blue-box1" @click="showModel('LX');">
							<h3>联系方式</h3>
						</div>
					</div>
					<div ref="SJ" class=" big-box2 contact-box white-bj" :class="isSJR?'br_green':''">
						<ul class="contact-list">
							<li>
								<p id="WC">微信&emsp;&emsp;&emsp;&emsp;{{form.wechatNum}}</p>
							</li>
							<li id="ql" v-for="(item,index) in qqList">
								<p id="qp" v-if="item.id==0">QQ&emsp;&emsp;&emsp;&emsp;{{item.qqNum}}</p>
								<p id="qp" v-else>QQ{{item.id}}&emsp;&emsp;&emsp;&emsp;{{item.qqNum}}</p>
							</li>
							<!-- <li id="wl">
								<p id="wp">微博&emsp;&emsp;&emsp;&emsp;</p>
							</li> -->
							<li id="wl" v-for="(item,index) in wbList">
								<p id="wp" v-if="item.id==0">微博&emsp;&emsp;&emsp;&emsp;{{item.wbName}}</p>
								<p id="wp" v-else>微博{{item.id}}&emsp;&emsp;&emsp;&emsp;{{item.wbName}}</p>
							</li>
						</ul>
						<!--遮罩-->
						<div class="blue-box2" @click="showModel('SJ');">
							<h3>社交信息</h3>
						</div>
					</div>
					<div ref="DZ" class=" big-box3 contact-box white-bj" :class="isDZR?'br_green':''">
						<ul class="contact-list">
							<li id="al">
								<p id="a">地址&emsp;&emsp;&emsp;&emsp;{{form.address}}</p>
							</li>
							<li :id="'al'+item.id" v-for="(item,index) in adList">
								<p :id="'a'+item.id">地址{{item.id}}&emsp;&emsp;&emsp;&emsp;{{item.address}}</p>
							</li>
						</ul>
						<!--遮罩-->
						<div class="blue-box3" @click="showModel('DZ');">
							<h3>地址</h3>
						</div>
					</div>
					<div ref="GR" class=" big-box4 contact-box white-bj" :class="isGRR?'br_green':''">
						<ul class="contact-list">
							<li>
								<p id="pe">个人说明&emsp;&emsp;{{form.description}}</p>
							</li>

						</ul>
						<!--遮罩-->
						<div class="blue-box4" @click="showModel('GR');">
							<h3>个人说明</h3>
						</div>
					</div>
					<div class="phone-top" style="border-top:1px solid #E1E1E1">
						<img src="../assets/imgs/phone-bottom.png">
					</div>
				</div>
				<!--弹框-->
				<div id="param" class="mb-popou fl" :model="form">

					<!--弹框1封面-->
					<div class="popou-commen popou02 padding20 clearfix a-fadeinR" v-if="isFMR">
						<i class="trangle1"></i>
						<i class="cloose2" @click="delModel('FM');"></i>
						<ul class="com-list com-list2">
							<li class="pic-box clearfix">
								<label>头像：</label>
								<!-- <el-upload class="upload-avatar fl" :action="$api+'/upload/uploadImageFile'" :on-remove="handleAvatarRemove"
								 :on-success="handleAvatarSuccess" list-type="picture" :on-change="getAvatarChange">
									<el-button size="middle" type="primary">上传头像</el-button>
								</el-upload> -->
								<el-upload class="upload-avatar fl" :action="$api+'/upload/uploadImageFile'" :show-file-list="false" :on-success="handleAvatarSuccess" :on-change="getAvatarChange">
									<el-button size="middle" type="primary">上传头像</el-button>
								</el-upload>
								<div class="previewBox">
									<div v-if="form.avtarSrc&&form.avtarSrc.indexOf('/Head-bj')<0" style="width: 90px;height: 60px;border: 1px solid #E1E1E1;overflow: hidden;text-align: center;display: table;vertical-align: middle;">
										<div style="width: 90px;height: 60px;display: table-cell;text-align: center;vertical-align: middle;">
											<img :src="form.avtarSrc" alt="" style="max-width: 90px;max-height: 67px;">
										</div>
										<a href="javascript:void(0)" class="cloose111" @click="handlePicRemove" id="deleImage5"></a>
									</div>
								</div>
							</li>
							<li class="pic-box clearfix">
								<label class="fl">封面图：</label>
								<!-- <el-upload class="upload-avatar fl" :action="$api+'/upload/uploadImageFile'" :on-remove="handlePosterRemove"
								 :on-success="handlePosterSuccess" list-type="picture" :on-change="getPosterChange">
									<el-button size="middle" type="primary">上传封面图</el-button>
								</el-upload> -->
								<el-upload class="upload-avatar fl" :action="$api+'/upload/uploadImageFile'" :show-file-list="false" :on-success="handlePosterSuccess" :on-change="getPosterChange">
									<el-button size="middle" type="primary">上传封面图</el-button>
								</el-upload>
								<div class="previewBox">
									<div v-if="form.posterSrc&&form.posterSrc.indexOf('/pic_9')<0" style="width: 90px;height: 60px;border: 1px solid #E1E1E1;overflow: hidden;text-align: center;display: table;vertical-align: middle;">
										<div style="width: 90px;height: 60px;display: table-cell;text-align: center;vertical-align: middle;">
											<img :src="form.posterSrc" alt="" style="max-width: 90px;max-height: 67px;">
										</div>
										<a href="javascript:void(0)" class="cloose111" @click="handlePosterRemove" id="deleImage5"></a>
									</div>
								</div>
							</li>
							<p class="tishi-gray re-position">图片建议尺寸720*330px，居中展示建议尺寸720*450px</p>
							<li>
								<label>姓名：</label>
								<input id="ne" type="text" v-model="form.userName">
							</li>
							<li>
								<label>职位：</label>
								<input id="zw" type="text" v-model="form.position">
							</li>
							<li :id="item.id == 0?'lgs':'lgs'+index" v-for="(item,index) in comList">
								<!-- <label v-if="item.id == 0" v-html="!item.comName?'公司：':item.comName"></label>
								<label v-else v-html="!item.comName?'公司'+index+'：':item.comName"></label> -->
								<label v-html="item.id==0?'公司：':'公司'+item.id+'：'"></label>
								<input id="gs" name="gs" type="text" v-model="item.comName">
								<a href="javascript:void(0);" @click="addCom" v-if="item.id==0"><span class="add-icon"></span></a>
								<a href="javascript:void(0);" class="sc" @click="delCom(item.id)" v-else></a>
							</li>
							<li class="show-position">
								<label>展示位置：</label>
								<input type="hidden" id="rank" name="rank" v-model="showstyle">
								<a href="javascript:void(0);" @click="ShowSeat('LR');"><img src="../assets/imgs/show-1.png"></a>
								<a href="javascript:void(0);" @click="ShowSeat('UD');"><img src="../assets/imgs/show-2.png"></a>
								<a href="javascript:void(0);" @click="ShowSeat('RL');"><img src="../assets/imgs/show-3.png"></a>
							</li>
						</ul>
					</div>
					<!--弹框2-->
					<div class="popou-commen popou02 padding20 clearfix a-fadeinR" v-else-if="isLXR" style="margin-top: 274px;">
						<i class="trangle1"></i>
						<i class="cloose2" @click="delModel('LX');"></i>
						<ul class="contect-list com-list2 ">
							<li>
								<label>固定电话：</label>
								<input v-model="form.telphone" maxlength="20" type="text">
							</li>
							<li :id="item.id == 0?'lphone':'lphone'+index" v-for="(item,index) in phoneList">
								<label v-html="item.id==0?'移动电话：':'移动电话'+item.id+'：'"></label>
								<input id="phone" name="phone" type="text" maxlength="20" v-model="item.phoneNum" @change="checkPhone(item.phoneNum,index)">
								<a href="javascript:void(0);" @click="addPhone" v-if="item.id==0"><span class="add-icon"></span></a>
								<a href="javascript:void(0);" class="sc" @click="delPhone(item.id)" v-else></a>
							</li>
							<li :id="item.id == 0?'lfax':'lfax'+index" v-for="(item,index) in faxList">
								<label v-html="item.id==0?'传真：':'传真'+item.id+'：'"></label>
								<input id="fax" name="fax" type="text" maxlength="20" v-model="item.faxNum">
								<a href="javascript:void(0);" @click="addFax" v-if="item.id==0"><span class="add-icon"></span></a>
								<a href="javascript:void(0);" class="sc" @click="delFax(item.id)" v-else></a>
							</li>
							<li :id="item.id == 0?'lemail':'lemail'+index" v-for="(item,index) in emailList">
								<label v-html="item.id==0?'电子邮箱：':'电子邮箱'+item.id+'：'"></label>
								<input id="email" name="email" type="text" v-model="item.email" @change="checkEmail(item.email,index)">
								<a href="javascript:void(0);" @click="addEmail" v-if="item.id==0"><span class="add-icon"></span></a>
								<a href="javascript:void(0);" class="sc" @click="delEmail(item.id)" v-else></a>
							</li>
						</ul>
					</div>
					<!--弹框3-->
					<div class="popou-commen popou02 padding20 clearfix a-fadeinR" v-else-if="isSJR" style="margin-top: 466px;">
						<i class="trangle1"></i>
						<i class="cloose2" @click="delModel('SJ');"></i>
						<ul class="contect-list com-list2 ">
							<li>
								<label>微信号：</label>
								<input id="c" maxlength="20" type="text" v-model="form.wechatNum">
							</li>
							<li :id="item.id == 0?'lQQ':'lQQ'+index" v-for="(item,index) in qqList">
								<label v-html="item.id==0?'QQ：':'QQ'+item.id+'：'"></label>
								<input id="QQ" name="QQ" type="text" v-model="item.qqNum" maxlength="20">
								<a href="javascript:void(0);" @click="addQQ" v-if="item.id==0"><span class="add-icon"></span></a>
								<a href="javascript:void(0);" class="sc" @click="delQQ(item.id)" v-else></a>
							</li>
							<li :id="item.id == 0?'lWB':'lWB'+index" v-for="(item,index) in wbList">
								<label v-html="item.id==0?'微博：':'微博'+item.id+'：'"></label>
								<input id="WB" name="WB" type="text" v-model="item.wbName" maxlength="256">
								<a href="javascript:void(0);" @click="addWB" v-if="item.id==0"><span class="add-icon"></span></a>
								<a href="javascript:void(0);" class="sc" @click="delWB(item.id)" v-else></a>
							</li>
						</ul>
					</div>


					<!--弹框4-->
					<div class="popou-commen popou02 padding20 clearfix a-fadeinR" v-else-if="isDZR" style="margin-top: 600px;">
						<i class="trangle1"></i>
						<i class="cloose2" @click="delModel('DZ');"></i>
						<ul class="contect-list com-list2 com-list3 ">
							<li id="laddress">
								<label>地址：</label>
								<input id="address" type="text" v-model="form.address">
								<a href="javascript:void(0);" @click="chooseMap" class="adress-icon"><i></i>标注地址</a>
								<a href="javascript:void(0);" @click="addAddress"><span class="add-icon"></span></a>
							</li>
							<li :id="'laddress'+item.id" v-for="(item,index) in adList">
								<label v-html="'地址'+item.id+'：'"></label>
								<input :id="'address'+item.id" name="address" type="text" style="margin-left: 4px;" v-model="item.address">
								<a href="javascript:void(0);" class="sc" @click="delAddress(item.id)"></a>
							</li>
						</ul>
					</div>
					<!--弹框5-->
					<div class="popou-commen popou02 padding20 clearfix a-fadeinR" v-else-if="isGRR" style=" margin-top: 646px;">
						<i class="trangle1"></i>
						<i class="cloose2" @click="delModel('GR');"></i>
						<ul class="contect-list com-list4">
							<li class="clearfix">
								<label>个人说明：</label>
								<textarea id="x" v-model="form.description"></textarea>
							</li>
						</ul>
					</div>
				</div>
				<!-- 选择地图 -->
				<el-dialog title="标注地址" :visible.sync="mapShow" width="800px">
					<!-- <div v-loading="ImgLoading" class="imagealert">
						<img :src='imgurl' style="width: 100%; display: inline-block;"></img>
					</div> -->
					<div style="text-align: right;margin-bottom: 15px;padding: 0 80px;">
						<el-input placeholder="请输入" v-model="searchKey" style="width: 200px;margin-right: 20px;"></el-input>
						<el-button id="btn_search" type="primary" @click="mapSearch">搜索</el-button>
					</div>
					<baidu-map id="allmap" @ready="mapReady" @click="clickMap" :scroll-wheel-zoom="true">
						<bm-marker :position="point" animation="BMAP_ANIMATION_BOUNCE">
						</bm-marker>
					</baidu-map>
					<el-button type="primary" style="margin: 15px;" @click="saveMap">确定</el-button>
				</el-dialog>
				<!-- 预览 -->
				<el-dialog :visible.sync="yardImgshow" class="previewBox2" width="360px">
					<img src="../assets/imgs/phone-top.png" alt="">
					<div class="phoneBox">
						<!--左右排列-->
						<div id="LRRankPre" class="person-cover" v-show="showstyle=='LR'" style="position: relative;">
							<img class="kz" style="width: 100%;height: 100%;" :src="form.posterSrc" alt="">
							
						    <div class="person-head">
						        <img class="tz" :src="form.avtarSrc">
						    </div>
						    <div id="LRDiv" class="person-text">
						        <h3>
						            {{form.userName}}
						        </h3>
						        <p>
						            {{form.position}}
						        </p>
						        <p v-for="item in comList">
						            {{item.comName}}
						        </p>
						    </div>
						
						</div>
						
						<!--上下排列-->
						<div id="UDRankPre" class="person-cover person-cover2" v-show="showstyle=='UD'" style="position: relative;">
							<img class="kz" style="width: 100%;height: 100%;" :src="form.posterSrc" alt="">
						    <div class="person-head person-head2">
								<img class="tz" :src="form.avtarSrc">
						    </div>
						    <div id="UDDiv" class="person-text person-text2">
						        <h3>
									{{form.userName}}
						        </h3>
						       <p>
						           {{form.position}}
						       </p>
						       <p v-for="item in comList">
						           {{item.comName}}
						       </p>
						    </div>
						</div>
						
						<!--右左排列-->
						<div id="RLRankPre" class="person-cover" v-show="showstyle=='RL'" style=" position: relative;">
							<img class="kz" style="width: 100%;height: 100%;" :src="form.posterSrc" alt="">
						    <div class="person-head person-head3">
								<img class="tz" :src="form.avtarSrc">
						    </div>
						    <div id="RLDiv" class="person-text person-text3">
						        <h3>
						        	{{form.userName}}
						         </h3>
						        <p>
						            {{form.position}}
						        </p>
						        <p v-for="item in comList">
						            {{item.comName}}
						        </p>
						    </div>
						</div>
						<div class="big-box1 contact-box white-bj">
						    <ul class="contact-list">
								<li v-show="form.telphone">
									<p>固定电话&nbsp;&emsp;&emsp;{{form.telphone}}</p>
								</li>
								
								<template v-for="item in phoneList">
									<li v-show="item.phoneNum">
									    <p v-if="item.id == 0">移动电话&nbsp;&emsp;&emsp;{{item.phoneNum}}</p>
									    <p v-else>移动电话{{item.id}}&emsp;&emsp;{{item.phoneNum}}</p>
									</li>
								</template>
								
								<template v-for="item in faxList">
									<li v-show="item.faxNum">
									    <p v-if="item.id == 0">传真&nbsp;&emsp;&emsp;&emsp;&emsp;{{item.faxNum}}</p>
									    <p v-else>传真{{item.id}}&emsp;&emsp;&emsp;&emsp;{{item.faxNum}}</p>
									</li>
								</template>
								
								<template v-for="item in emailList">
									<li v-show="item.email">
									    <p v-if="item.id == 0">电子邮箱&nbsp;&emsp;&emsp;{{item.email}}</p>
									    <p v-else>电子邮箱{{item.id}}&emsp;&emsp;{{item.email}}</p>
									</li>
								</template>
								
						
						    </ul>
						</div>
						<div class=" big-box2 contact-box white-bj">
						    <ul class="contact-list">
						            <li v-show="form.wechatNum">
						                <p>微信&nbsp;&emsp;&emsp;&emsp;&emsp;{{form.wechatNum}}</p>
						            </li>
									
									<template v-for="item in qqList">
										<li v-if="item.qqNum">
										    <p v-if="item.id == 0">QQ&nbsp;&emsp;&emsp;&emsp;&emsp;{{item.qqNum}}</p>
										    <p v-else>QQ{{item.id}}&emsp;&emsp;&emsp;&emsp;{{item.qqNum}}</p>
										</li>
									</template>
									
									<template v-for="item in wbList">
										<li v-show="item.wbName">
										    <p v-if="item.id == 0">微博&nbsp;&emsp;&emsp;&emsp;&emsp;{{item.wbName}}</p>
										    <p v-else>微博{{item.id}}&emsp;&emsp;&emsp;&emsp;{{item.wbName}}</p>
										</li>
									</template>
						    </ul>
						</div>
						<div v-if="form.address" class=" big-box3 contact-box white-bj">
						    <ul class="contact-list">
								<li>
								    <p>地址&emsp;&emsp;&emsp;&emsp;{{form.address}}</p>
								</li>
								<li v-if="adList.length>0" v-for="item in adList">
								    <p>地址{{item.id}}&emsp;&emsp;&emsp;&emsp;{{item.address}}</p>
								</li>
						    </ul>
						</div>
						<div v-if="form.description" class=" big-box4 contact-box white-bj">
						    <ul class="contact-list">
						        <li>
						            <p>个人说明&emsp;&emsp;{{form.description}}</p>
						        </li>
						    </ul>
						</div>
					</div>
					<img src="../assets/imgs/phone-bottom.png" alt="">
				</el-dialog>
				<!--download-->
				<div class="download-box fr">
					<div class="popou-ma1">
						<p>手机扫一扫，预览最新效果</p>
						<div class="ma-box re-margin">
							<img id="idcodeImg" :src="codeSrc" v-show="codeShow">
						</div>
						<div class="download-btns clearfix" style="margin-bottom: 10px;">
							<!-- <input type="button" value="预览" onclick="savePerson('preview');">
							<input type="button" value="保存" onclick="savePerson('hold');"> -->
							<el-button type="primary" size="small" @click="savePerson(0)">预览</el-button>
							<el-button type="primary" size="small" @click="savePerson(1)">保存</el-button>
							<!-- <input id="button_id" type="button" value="码图设置" onclick="maTSZ();" style="display: none;"> -->
						</div>

						<div class="line"></div>
						<h3>选择码制</h3>
						<div class="popou-choose">
							<el-checkbox-group v-model="checkList" @change="onMzchange">
								<el-checkbox label="汉信码"></el-checkbox>
								<el-checkbox label="龙贝码"></el-checkbox>
								<el-checkbox label="GM码"></el-checkbox>
								<el-checkbox label="QR码"></el-checkbox>
							</el-checkbox-group>
						</div>
						<h3>选择码标</h3>
						<div class="popou-choose">
							<el-select v-model="mbVal" placeholder="请选择" @change="onMbchange">
								<el-option v-for="item in mbList" :key="item.identification_ID" :label="item.identification" :value="item.identification_ID">
								</el-option>
							</el-select>
						</div>
						<div class="btn-long" style="margin: 20px 0;">
							<el-button type="warning" @click="downloadCode">打包下载码图</el-button>
						</div>
					</div>
				</div>
				<input type="hidden" id="mycity" value="石家庄市">
				<input type="hidden" id="hidQRSrc" name="hidQRSrc" value="20220318135405125.jpg">
				<input type="hidden" id="hidLBSrc" name="hidLBSrc" value="20220318135405474.jpg">
				<input type="hidden" id="hidHXSrc" name="hidHXSrc" value="20220318135405224.jpg">
				<input type="hidden" id="hidGMSrc" name="hidGMSrc" value="20220318135405225.jpg">
				<input type="hidden" id="categoryregId" name="categoryregId">
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'personalEdit',
		data() {
			return {
				comName: "",
				comList: [{ // 公司列表
					id: 0,
					comName: undefined
				}],
				phoneList: [{ // 移动电话列表
					id: 0,
					phoneNum: ''
				}],
				faxList: [{ // 传真列表
					id: 0,
					faxNum: ''
				}],
				emailList: [{ // 电子邮箱列表
					id: 0,
					email: ''
				}],
				qqList: [{
					id: 0,
					qqNum: ''
				}],
				wbList: [{
					id: 0,
					wbName: ''
				}],
				LR: true, // 名片布局切换
				UD: false,
				RL: false,
				isFMR: true, // 弹窗展示、选中边框
				isLXR: false,
				isSJR: false,
				isDZR: false,
				isGRR: false,
				form: { // 编辑数据
					avtarSrc: require("../assets/imgs/Head-bj.png"), // 头像
					posterSrc: require("../assets/imgs/pic_9.png"), // 封面
					userName: "", // 姓名
					position: "", // 职位
					telphone: "", // 固定电话
					wechatNum: "", // 微信号
					address: "", // 地址
					description: "" // 个人说明
				},
				point: "", // 地图选点
				mapShow: false, // 地图
				center: {
					lng: 116.404,
					lat: 39.915
				},
				maps: '',
				searchKey: '', // 地图搜索关键字
				adList: [], // 地址列表
				hxChecked: false,
				lbChecked: false,
				gmChecked: false,
				qrChecked: false,
				mbList: [],
				mbVal: '',
				idcode: '',
				showstyle: 'LR', // 布局
				codeSrc: '',
				codeShow: false,
				checkList: ['QR码'],
				yardImgshow: false
			}
		},
		mounted() {
			this.$store.commit('resistopen')
			//           this.$store.state.resistshow =true;
			//			console.log(this.$store.state.resistshow )

		},
		created() {
			console.log(this.$getCookie('idcode'))
			if (this.$getCookie('idcode')) { // 编辑操作
				console.log(this.$getCookie('idcode'))
				this.idcode = this.$getCookie('idcode')
				this.getIdcodeInfo() // 获取详情
				this.codeShow = true // 显示预览二维码
			}
			this.getMblist() // 获取码标列表
			// console.log(this.form.avtarSrc,this.form.avtarSrc.indexOf('/Head-bj'))
			// console.log(this.form.posterSrc,this.form.posterSrc.indexOf('/pic_9'))
		},
		destroyed() {
			//			console.log(this.$store.state.resistshow )

			this.$store.commit('resistDestroy')
			console.log('destroyed')
			this.$delCookie('idcode')
		},
		methods: {
			getData(data, key) {
				return data.map((item, index) => {
					if(key == 'address') {
						index++
					}
					// if(item) {
						return {
							id: index,
							[key]: item
						}
					// }
				})
			},
			getIdcodeInfo() { // 详情
				this.$http.get(this.$api + '/lightapp/getLightAppByIdcode', {
					params: {
						idcode: this.idcode
					}
				}).then(res => {
					if (res.body.result === 1) {
						console.log(res.body.entity.moduleList)
						var that = this
						this.form = {
							avtarSrc: res.body.entity.moduleList.head.avatar ? res.body.entity.moduleList.head.avatar : require(
								"../assets/imgs/Head-bj.png"),
							posterSrc: res.body.entity.moduleList.head.cover ? res.body.entity.moduleList.head.cover : require(
								"../assets/imgs/pic_9.png"),
							userName: res.body.entity.moduleList.head.name,
							position: res.body.entity.moduleList.head.position,
							showstyle: res.body.entity.moduleList.head.showstyle,
							telphone: res.body.entity.moduleList.contact.tel,
							wechatNum: res.body.entity.moduleList.social.wechat,
							description: res.body.entity.moduleList.personal.personal
						}
						this.ShowSeat(this.form.showstyle) // 重排布局
						
						// address: {
						// 	address: addArr
						// }, 
						this.comList = this.getData(res.body.entity.moduleList.head.companyname,'comName')
						
						this.phoneList = this.getData(res.body.entity.moduleList.contact.phone,'phoneNum')
						
						this.faxList = this.getData(res.body.entity.moduleList.contact.fax,'faxNum')
						
						this.emailList = this.getData(res.body.entity.moduleList.contact.email,'email')
						
						this.qqList = this.getData(res.body.entity.moduleList.social.qq,'qqNum')
						
						this.wbList = this.getData(res.body.entity.moduleList.social.microblog,'wbName')
						
						if(res.body.entity.moduleList.address.address) {
							this.form.address = res.body.entity.moduleList.address.address[0]
							var adArr = res.body.entity.moduleList.address.address.slice(1)
							this.adList = this.getData(adArr,'address')
						} else {
							this.form.address = ''
						}
						
						
						
					} else {
						// this.tableData = [];
					}
				}, rej => {
					this.$message.error('数据连接失败，请尝试刷新');

				})
			},
			// 头像
			handleAvatarSuccess(res, file) {
				this.form.avtarSrc = res.entity.imageUrl+res.entity.imageBig;
				console.log(this.form.avtarSrc)
			},
			// handleAvatarRemove(file) {
			// 	this.form.avtarSrc = require("../assets/imgs/Head-bj.png")
			// },
			getAvatarChange(file, fileList) {
				if (fileList.length > 1) {
					fileList.splice(0, 1);
				}
			},
			handlePicRemove() {
				this.form.avtarSrc = require("../assets/imgs/Head-bj.png")
			},
			// 封面图
			handlePosterSuccess(res, file) {
				this.form.posterSrc = res.entity.imageUrl+res.entity.imageBig;
			},
			// handlePosterRemove(file) {
			// 	this.form.posterSrc = require("../assets/imgs/pic_9.png")
			// },
			getPosterChange(file, fileList) {
				if (fileList.length > 1) {
					fileList.splice(0, 1);
				}
			},
			handlePosterRemove() {
				this.form.posterSrc = require("../assets/imgs/pic_9.png")
			},
			// 追加公司
			addCom: function() {
				// console.log(this.comList.length)
				var len = this.comList.length
				if (len > 2) {
					this.$message.warning('公司最多显示3个！')
				} else {
					this.comList.push({
						// id: len--,
						id: len == 1 ? len-- : this.comList[len - 1].id + 1,
						comName: ''
					})
				}
			},
			// 删除
			delCom: function(id) {
				console.log(id)
				var that = this
				this.comList.forEach(function(item, index) {
					if (item.id == id) {
						that.comList.splice(index, 1)
					}
				})
			},
			// 切换名片布局
			ShowSeat: function(pos) {
				this.showstyle = pos
				switch (pos) {

					case 'LR':
						this.LR = true
						this.UD = false
						this.RL = false
						break;
					case 'UD':
						this.LR = false
						this.UD = true
						this.RL = false
						break;
					case 'RL':
						this.LR = false
						this.UD = false
						this.RL = true
						break;

					default:
						this.LR = true
						this.UD = false
						this.RL = false
						break;
				}
			},
			// 增加电话
			addPhone: function() {
				var len = this.phoneList.length
				if (len > 2) {
					this.$message.warning('移动电话最多显示3个！')
				} else {
					this.phoneList.push({
						// id: len--,
						id: len == 1 ? len-- : this.phoneList[len - 1].id + 1,
						phoneNum: ''
					})
				}
			},
			// 删除
			delPhone: function(id) {
				var that = this
				this.phoneList.forEach(function(item, index) {
					if (item.id == id) {
						that.phoneList.splice(index, 1)
					}
				})
			},
			// 手机号验证
			checkPhone: function(val, idx) {
				// const {
				// 	value
				// } = val
				var myreg = /^[1][3,4,5,7,8,9][0-9]{9}$/;
				if (!myreg.test(val)) {
					this.$message.error('请填写正确的手机号码!')
					this.phoneList[idx].phoneNum = ''
				} 
				// else {
				// 	this.$message.success('手机号码填写正确')
				// }
			},
			// 增加传真
			addFax: function() {
				var len = this.faxList.length
				if (len > 2) {
					this.$message.warning('传真最多显示3个！')
				} else {
					this.faxList.push({
						// id: len--,
						id: len == 1 ? len-- : this.faxList[len - 1].id + 1,
						faxNum: ''
					})
				}
			},
			// 删除
			delFax: function(id) {
				var that = this
				this.faxList.forEach(function(item, index) {
					if (item.id == id) {
						that.faxList.splice(index, 1)
					}
				})
			},
			// 增加电子邮箱
			addEmail: function() {
				var len = this.emailList.length
				if (len > 2) {
					this.$message.warning('电子邮箱最多显示3个！')
				} else {
					this.emailList.push({
						// id: len--,
						id: len == 1 ? len-- : this.emailList[len - 1].id + 1,
						email: ''
					})
				}
			},
			// 删除
			delEmail: function(id) {
				var that = this
				this.emailList.forEach(function(item, index) {
					if (item.id == id) {
						that.emailList.splice(index, 1)
					}
				})
			},
			// 邮箱验证
			checkEmail: function(val, idx) {
				console.log(val, idx)
				var myreg = /^\w+@[a-z0-9]+\.[a-z]{2,4}$/
				if (!myreg.test(val)) {
					this.$message.error('请填写正确的邮箱!')
					this.emailList[idx].email = ''
				} else {
					this.$message.success('邮箱填写正确')
				}
			},
			// 增加qq
			addQQ: function() {
				var len = this.qqList.length
				if (len > 2) {
					this.$message.warning('QQ最多显示3个！')
				} else {
					this.qqList.push({
						// id: len--,
						id: len == 1 ? len-- : this.qqList[len - 1].id + 1,
						qqNum: ''
					})
				}
			},
			// 删除
			delQQ: function(id) {
				var that = this
				this.qqList.forEach(function(item, index) {
					if (item.id == id) {
						that.qqList.splice(index, 1)
					}
				})
			},
			// 增加微博
			addWB: function() {
				var len = this.wbList.length
				if (len > 2) {
					this.$message.warning('微博最多显示3个！')
				} else {
					this.wbList.push({
						// id: len--,
						id: len == 1 ? len-- : this.wbList[len - 1].id + 1,
						wbName: ''
					})
				}
			},
			// 删除
			delWB: function(id) {
				var that = this
				this.wbList.forEach(function(item, index) {
					if (item.id == id) {
						that.wbList.splice(index, 1)
					}
				})
			},
			showModel: function(info) {
				switch (info) {
					case 'Rank':
						var dom = this.$refs.Rank
						// console.log(dom.offsetTop)
						this.isFMR = true
						this.isLXR = false,
							this.isSJR = false,
							this.isDZR = false,
							this.isGRR = false
						break;

					case 'LX':
						var dom = this.$refs.LX
						// console.log(dom.offsetTop)
						this.isFMR = false
						this.isLXR = true,
							this.isSJR = false,
							this.isDZR = false,
							this.isGRR = false
						break;

					case 'SJ':
						var dom = this.$refs.SJ
						// console.log(dom.offsetTop)
						this.isFMR = false
						this.isLXR = false,
							this.isSJR = true,
							this.isDZR = false,
							this.isGRR = false
						break;

					case 'DZ':
						var dom = this.$refs.DZ
						// console.log(dom.offsetTop)
						this.isFMR = false
						this.isLXR = false,
							this.isSJR = false,
							this.isDZR = true,
							this.isGRR = false
						break;

					case 'GR':
						var dom = this.$refs.GR
						// console.log(dom.offsetTop)
						this.isFMR = false
						this.isLXR = false,
							this.isSJR = false,
							this.isDZR = false,
							this.isGRR = true
						break;
				}
			},
			delModel: function(info) {
				switch (info) {
					case 'FM':
						this.isFMR = false
						break;
					case 'LX':
						this.isLXR = false
						break;
					case 'SJ':
						this.isSJR = false
						break;
					case 'DZ':
						this.isDZR = false
						break;
					case 'GR':
						this.isGRR = false
						break;
					default:

				}
			},
			chooseMap: function() {
				this.mapShow = true
			},
			mapReady({
				BMap,
				map
			}) {
				// 选择一个经纬度作为中心点
				map.clearOverlays();
				this.point = new BMap.Point(116.331398, 39.897445);
				map.centerAndZoom(this.point, 12);
				this.maps = map
			},
			clickMap: function(e) {
				// console.log(e)
				var that = this
				this.center.lng = e.point.lng
				this.center.lat = e.point.lat
				this.maps.clearOverlays();
				var new_point = new BMap.Point(e.point.lng, e.point.lat);
				var marker = new BMap.Marker(new_point); // 创建标注
				this.maps.addOverlay(marker); // 将标注添加到地图中

				var geoc = new BMap.Geocoder();
				var pt = e.point;
				geoc.getLocation(pt, function(rs) {
					var addComp = rs.addressComponents;
					that.form.address = addComp.province + addComp.city + addComp.district + addComp.street + addComp.streetNumber
				});
			},
			mapSearch: function() {
				// console.log(this.searchKey)
				var local = new BMap.LocalSearch(this.maps, {
					renderOptions: {
						map: this.maps
					}
				});
				local.search(this.searchKey);
			},
			saveMap: function() {
				this.mapShow = false
			},
			// 新增地址
			addAddress: function() {
				var len = this.adList.length
				if (len > 2) {
					this.$message.warning('地址最多显示3个！')
				} else {
					this.adList.push({
						id: len == 0 ? len + 1 : this.adList[len - 1].id + 1,
						address: ''
					})
				}
			},
			// 删除
			delAddress: function(id) {
				var that = this
				this.adList.forEach(function(item, index) {
					if (item.id == id) {
						that.adList.splice(index, 1)
					}
				})
			},
			// 保存数据
			savePerson: function(status) {
				var uploadAvatar = true
				if (this.form.avtarSrc.indexOf('/Head-bj') > -1) {
					uploadAvatar = false
				}
				var uploadPoster = true
				if (this.form.posterSrc.indexOf('/pic_9') > -1) {
					uploadPoster = false
				}
				if (!this.form.userName) {
					this.$message.warning('请输入姓名')
					return false
				}
				if (!this.form.position) {
					this.$message.warning('请输入职位')
					return false
				}
				if (this.comList.length < 1 || !this.comList[0].comName) {
					this.$message.warning('请最少输入一个公司')
					return false
				}
				var comArr = []
				if (this.comList.length > 0) {
					this.comList.forEach((item, index) => {
						comArr.push(item.comName)
					})
				}

				var phoneArr = []
				if (this.phoneList.length > 0) {
					this.phoneList.forEach((item, index) => {
						phoneArr.push(item.phoneNum)
					})
				}

				var faxArr = []
				if (this.faxList.length > 0) {
					this.faxList.forEach((item, index) => {
						faxArr.push(item.faxNum)
					})
				}

				var emailArr = []
				if (this.emailList.length > 0) {
					this.emailList.forEach((item, index) => {
						emailArr.push(item.email)
					})
				}

				var qqArr = []
				if (this.qqList.length > 0) {
					this.qqList.forEach((item, index) => {
						qqArr.push(item.qqNum)
					})
				}

				var wbArr = []
				if (this.wbList.length > 0) {
					this.wbList.forEach((item, index) => {
						wbArr.push(item.wbName)
					})
				}

				var addArr = []
				if (this.form.address) {
					addArr.push(this.form.address)
				}
				if (this.adList.length > 0) {
					this.adList.forEach((item, index) => {
						addArr.push(item.address)
					})
				}

				var param = {
					idcode: this.idcode ? this.idcode : '',
					template_id: 2, // 个人名片
					moduleList: {
						head: {
							avatar: uploadAvatar ? this.form.avtarSrc : '', //头像
							cover: uploadPoster ? this.form.posterSrc : '', //封面
							name: this.form.userName, //名称
							position: this.form.position, // 职位
							companyname: comArr, // 公司名
							showstyle: this.showstyle, // 布局
						},
						contact: {
							tel: this.form.telphone,
							phone: phoneArr,
							fax: faxArr,
							email: emailArr
						},
						social: {
							wechat: this.form.wechatNum,
							qq: qqArr,
							microblog: wbArr
						},
						address: {
							address: addArr
						},
						personal: {
							personal: this.form.description
						}
					}
				}
				// console.log(param,JSON.stringify(param))
				this.$http.post(this.$api + '/lightapp/savePersonCode', JSON.stringify(param)).then(res => {
					if (res.body.result === 1) {
						// 点预览时，调接口保存数据，成功后弹出预览窗口；
						// 点保存是，调接口保存数据，成功后询问“是否继续编辑”
						this.idcode = res.body.entity.idcode // 继续编辑或者预览后在编辑改成编辑状态后保存要发送idcode参数
						this.$setCookie('idcode', this.idcode)
						if (status == 0) { // 预览
							this.yardImgshow = true
							this.showCode()
						} else if (status == 1) { // 保存
							// this.$message({
							// 	message: '保存成功，',
							// 	type: 'success'
							// });
							// this.$router.go(-1)
							this.$confirm('保存成功,是否继续编辑?', '提示', {
								confirmButtonText: '确定',
								cancelButtonText: '取消',
								type: 'warning'
							}).then(() => {
								console.log('继续编辑')
							}).catch(() => {
								console.log('返回列表')
								this.$router.go(-1)
							});
						}

					} else {
						this.$message.error(res.body.message);
					}
				})
			},
			// 获取码标列表
			getMblist() {
				this.$http.get(this.$api + '/lightapp/getIdentificationList', {
					params: {
						idcode: this.idcode,
					}
				}).then(res => {
					if (res.body.result === 1) {
						console.log(res.body.entity)
						this.mbList = []
						res.body.entity.forEach((item, index) => {
							this.mbList.push({
								identification_ID: item.identification_ID,
								identification: item.identification
							})
							// this.checkList.push(item.)
						})
						this.mbVal = res.body.entity[0].identification_ID
						this.identification_ID = res.body.entity[0].identification_ID
						if (this.identification_ID) {
							this.showCode() // 生成码图
						}

					} else {
						this.identification_ID = ''
					}
				}, rej => {
					this.$message.error('数据连接失败，请尝试刷新');

				})
			},
			// 监听码标下拉切换
			onMbchange(val) {
				this.identification_ID = val
				this.showCode()
			},
			// 监听码制选择
			onMzchange() {
				console.log(this.checkList)
			},
			// 预览生成码图
			showCode() {
				// console.log(this.identification_ID)
				this.$http.get(this.$api + '/CodeImage/createCodeImage', {
					params: {
						idcode: this.idcode,
						identificationID: this.identification_ID
					}
				}).then(res => {
					if (res.body.result === 1) {
						// console.log(res.body.entity)
						this.mtList = res.body.entity.imgList
						this.codeSrc = res.body.entity.baseUrl + res.body.entity.imgList.QR码
						this.codeShow = true
						// console.log(this.codeSrc)
					} else {
						// this.tableData = [];
					}
				}, rej => {
					this.$message.error('数据连接失败，请尝试刷新');

				})
			},
			downloadCode() { // 打包下载码图
				console.log(this.checkList, '选中的码制')
				console.log(this.mtList, '码图列表')
				var idcode = this.$getCookie('idcode')
				if (!idcode) {
					this.$message.warning('请先预览或保存后再打包下载码图！')
					return false
				}
				var fileNames_arr = []
				if (this.checkList.length > 0 && this.mtList) {
					this.checkList.forEach((item, index) => {
						for (let key in this.mtList) {
							if (item == key) {
								fileNames_arr.push(this.mtList[item])
							}
						}
					})
				} else {
					this.$message.warning('请先选择码制！')
					return false
				}
				var fileNames = fileNames_arr.join(',')
				// console.log(fileNames)
				// console.log(this.$api + "/CommonMethod/ZipDownloadsBatch/?fileNames=" + fileNames + "&filePath=CreateCode")
				location.href = this.$api + "/CommonMethod/ZipDownloadsBatch/?fileNames=" + fileNames + "&filePath=CreateCode";
			},
		}
	}
</script>
<style>
	.popou-choose {
		display: flex;
		flex-direction: row;
		justify-content: space-around;
	}

	.popou-choose .el-checkbox {
		margin-right: 5px !important;
	}

	#allmap {
		height: 600px;
		width: 600px;
		margin: 0 auto;
	}

	.br_green {
		border-right: 2px solid #4caf50;
	}

	.contect-list li label {
		display: inline-block;
		width: 70px;
	}

	#content {
		/*width: 82.7%;*/
		width: 100%;
		min-width: 1060px;
		padding: 20px;
		-moz-box-sizing: border-box;
		-webkit-box-sizing: border-box;
		-o-box-sizing: border-box;
		-ms-box-sizing: border-box;
		box-sizing: border-box;
	}

	#model1 .left {
		width: 52.6%;
		float: left;
		background: #fff;
		min-width: 530px;
		border: 1px solid #e8e8e8;
		border-top: none;
		-moz-box-sizing: border-box;
		-webkit-box-sizing: border-box;
		-o-box-sizing: border-box;
		-ms-box-sizing: border-box;
		box-sizing: border-box;
	}

	#model1 .left.right {
		width: 46.6%;
		min-width: 475px;
		float: right;
		-moz-box-sizing: border-box;
		-webkit-box-sizing: border-box;
		-o-box-sizing: border-box;
		-ms-box-sizing: border-box;
		box-sizing: border-box;
	}

	#model1 .left .major {
		width: 201px;
		height: 202px;
		/*background: url("../img/codebg.png") no-repeat;*/
		background-size: 100%;
		position: relative;
		float: left;
		transition: all .5s;
	}

	#model1 .left .major img {
		width: 100px;
		height: 100px;
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		transition: all 1s;
	}

	#model1 .l_top {
		padding: 29px 40px;
		min-height: 216px;
		transition: all .5s;
	}

	#model1 .l_top li {
		display: inline-block;
		height: 85px;
		border: 1px solid #e3e3e3;
		float: left;
		width: 131px;
		margin-bottom: 13px;
		transition: all .5s;
		position: relative;
	}

	#model1 .l_top .current {
		border: 1px solid #f09d1a;
	}

	#model1 .l_top .right-icon {
		display: block;
		width: 24px;
		height: 24px;
		position: absolute;
		right: 0;
		bottom: 0;
	}

	#model1 .l_top li:nth-child(2n-1) {
		margin-right: 30px;
	}

	#model1 .l_top li img {
		margin: 7px 10px;
	}

	#model1 .l_top li div {
		height: 85px;
		line-height: 85px;
		width: 37px;
		background: #f2f2f2;
		float: right;
		text-align: center;
	}

	#model1 .l_top li span {
		display: inline-block;
		font-size: 14px;
		width: 20px;
		color: #767676;
		vertical-align: middle;
		line-height: 20px;
	}

	#model1 .l_top ul {
		width: 300px;
		float: left;
		margin-left: 30px;
		transition: all 1s;
	}

	#model1 .l_bot {
		width: 100%;
		height: 60px;
		line-height: 60px;
		font-size: 16px;
		border-top: 1px solid #e8e8e8;
	}

	#model1 .l_bot a {
		display: inline-block;
		width: 50%;
		text-align: center;
		color: #298bef;
		float: left;
		background: #fafafa;
	}

	#model1 .l_bot a:hover {
		font-weight: 700;
	}

	#model1 .l_bot a:nth-child(1) {
		border-right: 1px solid #e8e8e8;
		box-sizing: border-box;
		-moz-box-sizing: border-box;
		-webkit-box-sizing: border-box;
		-o-box-sizing: border-box;
		-ms-box-sizing: border-box;

	}

	#model1 .right {
		text-align: center;
	}

	#model1 .right .floor {
		margin: 0 auto 24px;
		height: 68px;
		width: 68px;
		border-radius: 50%;
		background: #f7f7f7;
		border: 1px solid #e5e5e5;
		text-align: center;
		line-height: 66px;
	}

	#model1 .right .floor img {
		width: 41px;
		height: 37px;
		display: inline-block;
		vertical-align: middle;
	}

	#model1 .right .l_top p {
		margin-bottom: 10px;
	}

	.font12 {
		font-size: 12px;
		color: #999;
		margin-bottom: 9px !important;
	}

	#model1 .right .l_top .icon span {
		color: #e62323;
		line-height: 14px;
		vertical-align: middle;
	}

	#model1 .right .l_top .icon i {
		display: inline-block;
		width: 14px;
		height: 14px;
		/* background: url("../img/mark.png") no-repeat; */
		background-size: 100%;
		margin-right: 5px;
		vertical-align: middle;
	}

	#model2 {
		margin: 14px 0;
	}

	#model2 .left {
		width: 36%;
		min-width: 368px;
		float: left;
		background: #fff;
		border: 1px solid #e8e8e8;
		border-top: none;
		-moz-box-sizing: border-box;
		-webkit-box-sizing: border-box;
		-o-box-sizing: border-box;
		-ms-box-sizing: border-box;
		box-sizing: border-box;
	}

	#model2 .left.right {
		width: 63%;
		min-width: 640px;
		float: right;
		-moz-box-sizing: border-box;
		-webkit-box-sizing: border-box;
		-o-box-sizing: border-box;
		-ms-box-sizing: border-box;
		box-sizing: border-box;
	}

	#model2 .l_top2 {
		height: 52px;
		line-height: 52px;
		font-size: 16px;
		border-bottom: 1px solid #e1e1e1;
	}

	#model2 .l_top2 span {
		border-left: 4px solid #58a4f3;
		padding-left: 10px;
		margin-left: 12px;

	}

	#model2 .l_bot2 p span {
		margin-left: 10px;
	}

	#model2 .l_bot2 {
		text-align: center;
		line-height: 34px;
		font-size: 16px;
		padding-bottom: 32px;
	}

	#model2 .l_bot2 .mainnum {
		font-size: 18px;
		line-height: 83px;
		margin-top: 15px;
	}

	#model2 .l_bot2 .mainnum span {
		font-size: 36px;
		margin-left: 0;
		margin-right: 10px;
	}

	#model2 .r_bot2 {
		padding: 35px 40px;
	}

	#model2 .r_bot2 li {
		height: 170px;
		padding: 22px 9px 11px;
		-moz-box-sizing: border-box;
		-webkit-box-sizing: border-box;
		-o-box-sizing: border-box;
		-ms-box-sizing: border-box;
		box-sizing: border-box;
		width: 31.5%;
		float: left;
		border: 1px solid #e1e1e1;
		font-size: 14px;
		position: relative;
		text-align: center;
	}

	#model2 .r_bot2 li p {
		color: #666;
		text-align: left;
		line-height: 24px;
		margin-top: 24px;
	}

	#model2 .r_bot2 li a {
		color: #666666;
		position: absolute;
		bottom: 10px;
		right: 10px;
	}

	#model2 .r_bot2 li a:hover {
		color: #298BEF;
	}

	#model2 .r_bot2 li:nth-child(2) {
		margin: 0 2%;
	}

	#model3 {
		width: 100%;
		min-width: 1000px;
		background: #fff;
		border: 1px solid #e8e8e8;
		border-top: none;
	}

	#model3 .top {
		height: 52px;
		line-height: 52px;
		font-size: 16px;
		border-bottom: 1px solid #e1e1e1;
	}

	#model3 .top span {
		border-left: 4px solid #58a4f3;
		padding-left: 10px;
		margin-left: 12px;
	}

	#model3 .main {
		padding: 26px 10px;
		color: #666;
	}

	#model3 .main input {
		height: 19px;
	}

	#model3 .main input.name {
		width: 244px;
	}

	#model3 .main input.time {
		width: 100px;
	}

	#model3 button {
		background: none;
		width: 98px;
		height: 35px;
		line-height: 35px;
		text-align: center;
		color: #298bef;
		border: 1px solid #298bef;
		float: right;
		/* margin-right: 20px;*/
	}

	#model3 button:hover {
		background: #298BEF;
		color: #FFFFFF;

	}

	#model3 select {
		width: 172px;
		height: 35px;
	}

	.mar10 {
		margin-right: 10px;
	}

	.mal10 {
		margin-left: 200px;
		margin-top: -48px;
	}

	.mal101 {
		margin-left: 10px;
		margin-top: -48px;
	}

	.mar25 {
		margin-left: 25px;
		margin-right: 10px;
	}

	.mar6 {
		margin: 0 6px;
	}

	.mat20 {
		margin-top: 20px;
	}

	.condition input {
		border: 1px solid #E1E1E1;
	}

	.condition select {
		border: 1px solid #E1E1E1;
	}

	.tab-jl {
		border: 1px solid #E1E1E1;
	}

	.tab-jl th {
		text-align: center;
		line-height: 36px;
		background-color: #fcfcfc;
		border-bottom: 1px solid #E1E1E1;
	}

	.tab-jl td {
		line-height: 36px;
		text-align: center;
		font-size: 12.5px;
		border-bottom: 1px solid #E1E1E1;
		box-sizing: border-box;
	}

	.tab-cz a {
		display: inline-block;
		color: #298BEF;
		margin: 0 10px;
	}

	.tab-jl tr:nth-child(odd) {
		background: #fcfcfc;
	}

	.btn-more {
		text-align: center;
		margin-top: 10px;
	}

	.btn-more a {
		display: block;
		color: #f09d1a;
	}

	.fl {
		float: left;
	}

	.fr {
		float: right;
	}

	.clearfix:before,
	.clearfix:after {
		content: '';
		display: table;
	}

	.clearfix:after {
		clear: both;
	}

	.clearboth:after {
		display: block;
		clear: both;
		content: "";
		overflow: hidden;
		height: 0;
	}

	.person-cover {
		width: 100%;
		height: 230px;
		/* background: url(../assets/imgs/pic_9.png) no-repeat center; */
		background-size: cover;
		/* position: relative; */
	}

	.person-cover2 {
		height: 260px;
	}

	.person-head {
		width: 90px;
		height: 90px;
		border-radius: 90px;
		position: absolute;
		top: 75px;
		left: 20px;
		overflow: hidden;
	}

	.person-head img {
		width: 90px;
		height: 90px;
	}

	.person-head2 {
		position: absolute;
		left: 50% !important;
		margin-left: -45px;
		top: 20px !important;
	}

	.person-head3 {
		position: absolute;
		left: inherit;
		right: 20px !important;
		top: 75px;
	}

	.person-text {
		position: absolute;
		top: 84px;
		left: 130px;
		text-align: left;
	}

	.person-text2 {
		text-align: center;
		position: absolute;
		top: 120px;
		left: 50%;
		margin-left: -110px;
	}

	.person-text2 p {
		width: 220px !important;
	}

	.person-text3 {
		position: absolute;
		left: inherit;
		top: 84px;
		right: 130px !important;
		text-align: right;
	}

	.person-text h3 {
		color: #FFFFFF;
		font-size: 18px;
		font-weight: normal;
	}

	.person-text p {
		color: #FFFFFF;
		margin-top: 6px;
		width: 190px;
	}

	.contact-list {
		margin: 0;
		padding: 0;
	}

	.contact-list li {
		box-sizing: border-box;
		padding: 14px 20px;
		border-top: 1px solid #E1E1E1;
		text-align: left;
	}

	.contact-box {
		position: relative;
	}

	.re-position {
		position: relative;
		top: -10px;
		left: 40px;
	}

	.com-list2 input {
		margin-top: -5px;
		width: 250px !important;
	}

	.com-list3 input {
		width: 200px !important;
	}

	.com-list3 label {
		width: 60px !important;
	}

	.com-list3 .adress-icon {
		display: inline-block;
		color: #298BEF;
	}

	.com-list3 .adress-icon i {
		display: inline-block;
		width: 12px;
		height: 16px;
		background: url(../assets/imgs/address-1.png) no-repeat;
		background-size: 100%;
		position: relative;
		top: 3px;
		margin-left: 2px;
		margin-right: 2px;
	}

	.com-list4 label {
		display: inline-block;
		float: left;
		width: 90px !important;
		text-align: right;
	}

	.com-list4 textarea {
		display: inline-block;
		float: left;
		width: 260px;
		height: 100px;
		border: 1px solid #E1E1E1;
	}

	.add-icon {
		display: inline-block;
		width: 22px;
		height: 22px;
		background: url(../assets/imgs/add-2.png) no-repeat;
		background-size: 100%;
		position: relative;
		top: 5px;
		left: 10px;
	}

	.sc {
		display: inline-block;
		width: 22px;
		height: 22px;
		background: url(../assets/imgs/minus_03.png) no-repeat;
		background-size: 100%;
		position: relative;
		top: 5px;
		left: 12px;
	}

	.com-list2 li label {
		display: inline-block;
		width: 80px;
		text-align: right;
		color: #666666;
	}

	.show-position img {
		display: inline-block;
		margin-right: 3px;
	}

	.mb-phone {
		width: 360px;
	}

	.phone-top {
		height: 43px;
	}

	.phone-topCompany {
		height: 43px;
	}

	.cover-img img {
		width: 358px;
	}

	.border-bottom {
		border-bottom: 1px solid #F0F0F0;
	}

	.white-bj {
		background-color: #FFFFFF;
	}

	.cover-img h3 {
		text-align: center;
		padding: 10px;
		font-size: 16px;
		color: #666666;
	}

	.company-js h3 {
		font-size: 14px;
		font-weight: 700;
		color: #666666;
	}

	.company-js h3 i {
		display: inline-block;
		width: 16px;
		height: 16px;
		/* background: url(../images/icon-2.png) no-repeat center; */
		background-size: 100%;
		margin-right: 6px;
	}

	.padding16 {
		padding: 16px;
	}

	.com-img img {
		width: 100%;
	}

	.mat16 {
		margin-top: 16px;
	}

	.mat06 {
		margin-top: 6px;
	}

	.com-text font {
		/*text-indent: 24px;*/
		color: #666666;
		line-height: 1.6;
	}

	.com-text xmp {
		/*text-indent: 24px;*/
		color: #666666;
		line-height: 1.6;
	}

	.contect-list li {
		color: #666666;
		padding-top: 10px;
		text-align: left;
	}

	.contect-list li input {
		width: 280px;
		height: 32px;
		border: 1px solid #E1E1E1;
	}

	.contect-list .adress {
		display: inline-block;
		width: 12px;
		height: 16px;
		/* background: url(../images/address-2.png) no-repeat; */
		position: relative;
		top: 2px;
		left: 4px;
	}

	.popou-commen {
		width: 400px;
		background-color: #FFFFFF;
		border: 1px solid #E1E1E1;
		position: relative;
	}

	.popou-commen .trangle1 {
		display: block;
		width: 16px;
		height: 16px;
		background: url(../assets/imgs/trangle_03.png) no-repeat left;
		background-size: 100%;
		position: absolute;
		top: 20px;
		left: -16px;
	}

	.up-img {
		width: 90px;
		height: 60px;
		border: 1px solid #E1E1E1;
		overflow: hidden;
		text-align: center;
		display: table;
		vertical-align: middle;
		/*margin-top: 0px;*/
	}

	.up-img>div {
		width: 90px;
		height: 60px;
		display: table-cell;
		text-align: center;
		vertical-align: middle;
	}

	.up-img img {
		max-width: 90px;
		max-height: 67px;
	}

	.big-img-box {
		position: relative;
		width: 90px;
	}

	.big-img-box .cloose11 {
		display: block;
		width: 16px;
		height: 16px;
		/* background: url(../images/off-btn2.png) no-repeat; */
		position: absolute;
		top: -5px;
		right: -8px;
	}

	.big-img-box .cloose111 {
		display: block;
		width: 16px;
		height: 16px;
		/* background: url(../images/off-btn2.png) no-repeat; */
		position: absolute;
		top: 6px;
		right: -8px;
	}

	.mal20 {
		margin-left: 20px;
	}

	.up-img-box input {
		display: block;
		opacity: 0;
	}

	/*.up-img-box input:hover{*/
	/*background-color: #298BEF;*/
	/*color: #FFFFFF;*/
	/*}*/
	.tishi-gray {
		font-size: 12px;
		color: #999999;
		margin-top: 10px;
	}

	.popou-commen .cloose2 {
		display: block;
		width: 16px;
		height: 16px;
		background: url(../assets/imgs/cloose_03.jpg) no-repeat center;
		/*background-size: cover;*/
		position: absolute;
		right: 10px;
		top: 10px;
		cursor: pointer;
	}

	.hide {
		display: none;
	}

	.mb-popou {
		margin-left: 20px;
	}

	.padding20 {
		padding: 20px 0;
	}

	#content {
		font-size: 14px;
		height: 100%;
	}

	.com-list {
		margin-top: 20px;
	}

	.com-list li {
		margin-top: 5px;
		margin-bottom: 20px;
		display: flex;
		flex-direction: row;
		justify-content: flex-start;
		align-items: center;
	}

	.com-list input {
		width: 300px;
		height: 32px;
		border: 1px solid #E1E1E1;
		padding-left: 6px;
	}

	/* .pic-box button{
		float: left;
		display: block;
		width: 70px;
		height: 24px;
		background-color: #FFFFFF;
		color: #298BEF;
		border: 1px solid #298BEF;
		border-radius: 2px;
		margin-left: 6px;
	}
	.pic-box button:hover{
		background-color: #298BEF;
		color: #FFFFFF;
	} */

	.com-list label {
		float: left;
	}

	.com-list textarea {
		width: 300px;
		height: 80px;
		border: 1px solid #E1E1E1;
		padding-left: 6px;
		display: none;
	}

	.upload-avatar {
		display: inline-flex;
		flex-direction: row;
		justify-content: flex-start;
		align-items: center;
	}

	.el-upload-list {
		margin-left: 10px !important;
		max-height: 122px;
		overflow: hidden;
	}

	.big-box2,
	.big-box1,
	.big-box3 {
		position: relative;
		width: 100%;
		/*height: 100%;*/
	}

	.blue-box2,
	.blue-box1,
	.blue-box3,
	.blue-box4,
	.zzc {
		background: rgba(41, 139, 239, .76);
		position: absolute;
		top: 0;
		z-index: 1;
		width: 100%;
		height: 100%;

	}

	.blue-box1 h3,
	.blue-box2 h3,
	.blue-box3 h3,
	.blue-box4 h3 {
		color: #FFFFFF;
		font-size: 14px;
		text-align: center;
		position: absolute;
		top: 40%;
		left: 40%;
	}

	.blue-box1 {
		opacity: 0;
	}

	.big-box1:hover .blue-box1 {
		opacity: 1;
	}

	.blue-box2 {
		opacity: 0;
	}

	.big-box2:hover .blue-box2 {
		opacity: 1;
	}

	.blue-box3 {
		opacity: 0;
	}

	.big-box3:hover .blue-box3 {
		opacity: 1;
	}

	.blue-box4 {
		opacity: 0;
	}

	.big-box4:hover .blue-box4 {
		opacity: 1;
	}

	.download-box {
		background-color: #FFFFFF;
		width: 280px;
		border: 1px solid #E1E1E1;
	}

	.popou-ma1 {
		position: relative;
	}

	.popou-ma1 .cloose {
		position: absolute;
		top: -6px;
		right: 6px;
		cursor: pointer;
	}

	.re-margin {
		margin-top: 20px;
		margin-bottom: 10px;
	}

	.popou-ma1 .line {
		width: 100%;
		height: 1px;
		background-color: #dddddd;

	}

	.popou-ma1 h3 {
		text-align: center;
		margin: 10px;
	}

	.popou-ma1 p {
		text-align: center;
		color: #333333;
		margin-top: 20px;
	}

	.download-btns {
		text-align: center;
	}

	.download-btns input {
		width: 70px;
		height: 32px;
		background-color: #298BEF;
		color: #FFFFFF;
		border-radius: 2px;
		margin: 10px;

	}

	.download-btns input:hover {
		background-color: #6faff1;
	}

	.btn-long input:hover {
		background-color: #f4b148;
	}

	.ma-box {
		width: 220px;
		height: 220px;
		/*background: url(../img/codebg.png) no-repeat center;*/
		background-size: cover;
		-webkit-background-size: cover;
		text-align: center;
		margin: 30px auto;
	}

	.ma-box img {
		width: 220px;
		margin-top: 0px;
	}
</style>

<style lang="scss">
	.result-box {
		.el-table {
			.cell {
				text-align: center;
			}
		}
	}
</style>
